module.exports = __webpack_public_path__ + "static/img/052.516808e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fushen/052.png
// module id = I5JH
// module chunks = 0